export enum PeakTimeRebatesTransactionType {
  Unknown = 'unknown',
  Enroll = 'enroll',
  Update = 'update',
  Cancel = 'cancel',
}
